import {Level} from './level';
import {Config} from '../config';
import {LoggerProvider} from '../providers/logger-provider';

export class Logger {
    private readonly config: Config;
    private readonly provider: LoggerProvider;

    constructor(config: Config) {
        this.config = config;
        this.provider = new LoggerProvider();

        window.onerror = (error: string | Event) => {
            this.log(error);
            return false;
        } ;
    }

    log(message: string | Event, context?: any, level?: Level) {
        /* tslint:disable */
        console.log(message);
        /* tslint:enable */
        if (this.config.user && this.config.user.portalId) {
            const formattedMessage = this.format(message.toString(), context);
            const payload = this.payload(formattedMessage, level);
            return this.send(payload);
        } else {
            return Promise.resolve();
        }
    }

    format(message: string, context: any = ''): string {
        return `[${this.config.user.portalId}]
         [${location.href}]
         [${message}]
         [${JSON.stringify(context)}]`;
    }

    payload(message: string, level = Level.INFO): any {
        return {level, message};
    }

    send(body: any) {
        return this.provider.log(body);
    }
}
